import { FormEvent, useState } from 'react';
import { useAuth } from '@/auth/AuthContext';

/**
 * Ekran blokujący pełen dostęp gdy user ma flag `passwordChangeRequired` (po resecie admina).
 * Pokazuje się zamiast normalnego UI dopóki user nie zmieni hasła.
 */
export function ChangePasswordGate() {
  const { zmienPassword, logout, user } = useAuth();
  const [stare, setStare] = useState('');
  const [updated, setNew] = useState('');
  const [updated2, setNew2] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    if (updated.length < 8) { setErr('Hasło musi mieć min 8 znaków'); return; }
    if (updated !== updated2) { setErr('Hasła nie są zgodne'); return; }
    setBusy(true);
    try {
      await zmienPassword(stare, updated);
    } catch (e: any) {
      setErr(e.message ?? 'Błąd zmiany hasła');
    } finally { setBusy(false); }
  }

  return (
    <div className="min-h-screen grid place-items-center bg-[radial-gradient(ellipse_at_top,#1a2440_0%,#0b1220_60%)]">
      <div className="bg-white/5 border border-white/10 backdrop-blur p-10 rounded-2xl w-[440px] text-ink-100">
        <h1 className="text-white text-[18px] mb-1">Zmień hasło</h1>
        <div className="text-ink-300 text-[13px] mb-6">
          Administrator wymaga zmiany hasła przy pierwszym logowaniu.
          Użytkownik: <strong>{user?.login}</strong>
        </div>
        {err && <div className="text-red-300 text-[12px] mb-3">{err}</div>}
        <form onSubmit={submit} className="flex flex-col gap-3">
          <label className="flex flex-col gap-1">
            <span className="text-[12px] text-ink-300 font-semibold">Aktualne hasło tymczasowe</span>
            <input type="password" value={stare} onChange={e => setStare(e.target.value)} required
                   className="bg-white/5 border border-white/10 px-3 py-2.5 rounded-md text-white text-[14px]" />
          </label>
          <label className="flex flex-col gap-1">
            <span className="text-[12px] text-ink-300 font-semibold">Nowe hasło (min 8 znaków)</span>
            <input type="password" value={updated} onChange={e => setNew(e.target.value)} required minLength={8}
                   className="bg-white/5 border border-white/10 px-3 py-2.5 rounded-md text-white text-[14px]" />
          </label>
          <label className="flex flex-col gap-1">
            <span className="text-[12px] text-ink-300 font-semibold">Powtórz nowe hasło</span>
            <input type="password" value={updated2} onChange={e => setNew2(e.target.value)} required minLength={8}
                   className="bg-white/5 border border-white/10 px-3 py-2.5 rounded-md text-white text-[14px]" />
          </label>
          <button type="submit" disabled={busy} className="btn btn-water w-full justify-center py-2.5 mt-2">
            {busy ? 'Zapisuję…' : 'Zmień hasło'}
          </button>
          <button type="button" onClick={() => void logout()} className="text-[11px] text-ink-400 hover:text-ink-200 mt-1">
            Wyloguj
          </button>
        </form>
      </div>
    </div>
  );
}
